import React from 'react';

export default function SoftwarePortfolio() {
  return (
    <div>
      {/* Hero / Header Section */}
      <div className="home-container">
        <div className="allHeaderBg">
          <div className="allHeader-overlay d-flex align-items-center justify-content-center">
            <div>
              <h1
                className="head text-center text-white animate__animated animate__zoomIn allHeaderP"
              >
                Software Portfolio
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Portfolio Section */}
      <section
        className="clients-portfolio-section mt-4"
        style={{ backgroundColor: "#f1f3fe" }}
      >
        <div className="container mt-4">
          <div className="section-title mb-5 text-center">
            <h2>Web Software Projects</h2>
            <h3>
              Our Portfolio Of <span>Web Apps / Software Solutions</span>
            </h3>
          </div>

          <div className="container">
            {/* Row 1 */}
            <div className="row mt-4">
              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/desktop-pos-technicmentors.webp"
                  className="img-fluid portfolio-images"
                  alt="Desktop POS Software by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Desktop POS
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/portfolio/pos-technicmentors.png"
                  className="img-fluid portfolio-images"
                  alt="Web Based POS Software by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    POS Cloud Based - Standard
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/portfolio/resturent-management-system.png"
                  className="img-fluid portfolio-images"
                  alt="Restaurant Management System by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Restaurant Management System
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/tailoring-management-software.png"
                  className="img-fluid portfolio-images"
                  alt="Production Management System by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Production Management System
                  </h2>
                </div>
              </div>
            </div>

            {/* Row 2 */}
            <div className="row mt-4">
              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/capobiz-technicmentors.png"
                  className="img-fluid portfolio-images"
                  alt="Mini ERP Software by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    CapoBiz - Mini ERP
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/consultancy-management-system.png"
                  className="img-fluid portfolio-images"
                  alt="Consultancy Management System by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Consultancy Management System
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/capobrain-school-management.png"
                  className="img-fluid portfolio-images"
                  alt="School Management Software by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Capobrain - School Management
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/getwell-medicine.png"
                  className="img-fluid portfolio-images"
                  alt="Multivendor Medicines Marketplace by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Multivendor Medicines Marketplace
                  </h2>
                </div>
              </div>
            </div>

            {/* Row 3 */}
            <div className="row mt-4">
              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/wheel-bidz-cars-technicmentors.png"
                  className="img-fluid portfolio-images"
                  alt="Vehicles Auction Marketplace by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Vehicles Auction Marketplace
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/fertilizer-management-system.png"
                  className="img-fluid portfolio-images"
                  alt="Fertilizer Industry Management System by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Fertilizer Industry Management
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/tailoring-system-software.png"
                  className="img-fluid portfolio-images"
                  alt="Tailoring Management System by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Tailoring Management System
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/law-system-technicmentors.png"
                  className="img-fluid portfolio-images"
                  alt="Law Firm Management System by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Law Firm Management System
                  </h2>
                </div>
              </div>
            </div>

            {/* Row 4 - NEW PROJECTS */}
            <div className="row mt-4">
              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/office-management-system.png"  // ← change filename if needed
                  className="img-fluid portfolio-images"
                  alt="Office Management System by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Office Management System
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <img
                  src="assets/img/software portfolio/horticulture-management-system.png"  // ← change filename if needed
                  className="img-fluid portfolio-images"
                  alt="Horticulture Management System by Technic Mentors"
                />
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Horticulture Management System
                  </h2>
                </div>
              </div>

              {/* Empty columns to maintain grid alignment (optional - you can remove if you prefer) */}
              <div className="col-md-3 mb-4 d-none d-md-block"></div>
              <div className="col-md-3 mb-4 d-none d-md-block"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}